import React from "react";
import { FaInstagram, FaEnvelope, FaWhatsapp } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="py-10 text-center text-gray-600">
            <div className="flex items-center justify-center gap-8 max-w-6xl mx-auto mb-6">
                <div className="h-px flex-1 bg-gray-300" />

                <div className="flex gap-6 text-xl">
                    <a
                        href="https://www.instagram.com/dinarafar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-black hover:scale-110 transition duration-200 text-2xl"
                    >
                        <FaInstagram />
                    </a>

                    <a
                        href="https://wa.me/77014311654"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-black hover:scale-110 transition duration-200 text-2xl"
                    >
                        <FaWhatsapp />
                    </a>

                    <a
                        href="mailto:dinarafar@gmail.com"
                        className="hover:text-black hover:scale-110 transition duration-200 text-2xl"
                    >
                        <FaEnvelope />
                    </a>
                </div>

                <div className="h-px flex-1 bg-gray-300" />
            </div>

            <p className="text-xs tracking-widest uppercase text-gray-400">
                © {new Date().getFullYear()} Dinara Fariz
            </p>

            <p className="mt-2 text-[9px] md:text-[10px] tracking-[0.22em] uppercase text-gray-300">
                Website by Beck Mankeyev
            </p>
        </footer>
    );
};

export default Footer;